{
  "title": "Compulsion",
  "source": "Player's Handbook",
  "levelAndSchool": "4th-level enchantment",
  "level": 4,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V, S",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "Creatures of your choice that you can see within range and that can hear you must make a Wisdom saving throw. A target automatically succeeds on this saving throw if it can’t be charmed. On a failed save, a target is affected by this spell. Until the spell ends, you can use a bonus action on each of your turns to designate a direction that is horizontal to you. Each affected target must use as much of its movement as possible to move in that direction on its next turn. It can take its action before it moves. After moving in this way, it can make another Wisdom saving throw to try to end the effect.",
    "A target isn’t compelled to move into an obviously deadly hazard, such as a fire pit, but it will provoke opportunity attacks to move in the designated direction."
  ],
  "spellLists": ["bard"]
}
